import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-criteria',
  templateUrl: './criteria.component.html',
  styleUrls: ['./criteria.component.scss']
})
export class CriteriaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
